<template>
    <div class="services-details-area d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image text-center mb-4">
                        <img src="../../assets/images/services/facial-aesthetics/botox-etc/botox-main-page.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('botox_title') }}</h3></u>
                        <p>{{ $t('botox_p1') }}</p>
                        <p>{{ $t('botox_p2') }}</p> 
                        <p>{{ $t('botox_p3') }}</p>
                        <p>{{ $t('botox_p4') }}</p>
                        <p>{{ $t('botox_p5') }}</p>
                        <p>{{ $t('botox_p6') }}</p>
                        <p>{{ $t('botox_p7') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>



    export default {
        name: 'BotoxEtc',
        
    };
   
</script>
